<template>
    <div class="col-xl-4 col-lg-4">
        <div class="beyo-line row">
            <div class="beyoline-header col-xl-12">
                <div id="beyo-line" style="min-height: 285px;">
                    <apexchart type="bar" height="270" :options="line.options" :series="line.series"></apexchart>
                </div>
            </div>
            <div class="beyo-detail col-xl-12">
                <h3>Beyond the Lines <span class="badge badge-primary">6 hours ago</span></h3>
                <p>One Of the world,s brightest, young surf Srars, Kanoa lgarashi.</p>
                <div class="date-history">
                    <ul>
                        <li><img class="img-fluid" src="@/assets/images/dashboard/beyo-line/1.png" alt=""></li>
                        <li><img class="img-fluid" src="@/assets/images/dashboard/beyo-line/2.png" alt=""></li>
                        <li><img class="img-fluid" src="@/assets/images/dashboard/beyo-line/3.png" alt=""></li>
                        <li><img class="img-fluid" src="@/assets/images/dashboard/beyo-line/4.png" alt=""></li>
                        <li>
                            <h2>+ 350</h2>
                        </li>
                    </ul>
                    <div class="date-lable">
                        <h3>10</h3>
                        <p>june</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import beyoLine from "@/mixins/beyoLine"
export default {
    name: 'linePage.vue',
    mixins: [beyoLine],
}
</script>
